import { isIconKey, TIconKey } from "@/ui/components/primitives/Icon";
import { isImage, TImageProps } from "@/ui/components/primitives/Image";

import { TAlertAsset } from "./Alert.config";

export const isAlertAssetIconKey = (asset: TAlertAsset): asset is TIconKey => (
  isIconKey(asset)
);

export const isAlertAssetImage = (asset: TAlertAsset): asset is TImageProps => (
  isImage(asset)
);
